import ServicePageTemplate from '../ServicePageTemplate';

const ASSETS = {
  waterHeaters: "https://images.pexels.com/photos/6419128/pexels-photo-6419128.jpeg?auto=compress&cs=tinysrgb&w=1200",
};

const WaterHeatersService = () => {
  return (
    <ServicePageTemplate
      title="Water Heaters"
      subtitle="Hot Water Solutions"
      image={ASSETS.waterHeaters}
      description="Never run out of hot water again. BNPH provides expert water heater installation, repair, and replacement services for both traditional tank and modern tankless systems. We help you choose the right water heater for your home's needs and budget."
      features={[
        'Tank and tankless water heater expertise',
        'Same-day service available',
        'Energy-efficient options',
        'Professional installation',
        'Manufacturer warranty support',
        'Fast replacement services',
      ]}
      services={[
        'Water Heater Installation',
        'Water Heater Replacement',
        'Water Heater Repair',
        'Tankless Water Heaters',
        'Traditional Tank Heaters',
        'Gas Water Heaters',
        'Electric Water Heaters',
        'Water Heater Maintenance',
        'Anode Rod Replacement',
        'Sediment Flushing',
        'Thermostat Repair',
        'Leak Repair',
      ]}
      relatedServices={[
        { title: 'Boilers', link: '/services/boilers', description: 'Heating system installation and repair.' },
        { title: 'Residential', link: '/services/residential', description: 'Complete home plumbing services.' },
        { title: 'Remodeling', link: '/services/remodeling', description: 'Bathroom and kitchen renovations.' },
      ]}
    />
  );
};

export default WaterHeatersService;
